import { useCallback, useEffect, useState } from 'react';
import * as apiObject from 'api/apiObjects';
import type { ObjectStatusHistoryRow } from './types';

export const useObjectStatusHistory = (objectId: number | null | undefined, show: boolean) => {
    const [history, setHistory] = useState<ObjectStatusHistoryRow[]>([]);
    const [loading, setLoading] = useState(false);

    const reload = useCallback(async () => {
        if (!objectId) {
            setHistory([]);
            return;
        }
        setLoading(true);
        const rows = await apiObject.getObjectStatusHistory(objectId);
        setHistory(Array.isArray(rows) ? rows : []);
        setLoading(false);
    }, [objectId]);

    useEffect(() => {
        if (!show || !objectId) return;
        void reload();
    }, [show, objectId, reload]);

    return { history, loading, reload };
};
